import axios from 'axios';
import { REACT_APP_API_URL } from '../env';

const BASE_URL = REACT_APP_API_URL;


export const employeeApi = {
  addEmployee: async (employeeData) => {
    try {
      const formData = new FormData();

      Object.keys(employeeData).forEach(key => {
        if (key === 'employeeProfile' && employeeData[key]) {
          formData.append('employeeProfile', employeeData[key]);
        } else {
          formData.append(key, employeeData[key]);
        }
      });

      const response = await axios.post(`${BASE_URL}api/hrms/add-employee`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  resetEmployeePassword: async (employeeId, passwordData) => {
    try {
      const response = await axios.post(
        `${BASE_URL}api/hrms/reset-employee-password/${employeeId}`,
        passwordData,
        {
          withCredentials: true,
        }
      );

      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};
